// extracted by mini-css-extract-plugin
export default {"send_page_message":"SendPage_send_page_message__fnYjQ"};